export default __webpack_public_path__ + "static/media/rookie-min.e88244c7.png";